import { useAdjustmentCategoriesQuery } from "queries";

const useAdjustmentCategoriesColumn = () => {
	const { data: categories } = useAdjustmentCategoriesQuery();

	return {
		name: "category",
		type: "select" as const,
		loadOptions: () => ({
			options: categories,
			hasMore: false,
		}),
		getOptionLabel: option => option.displayName,
		getOptionValue: option => option.value,
		placeholder: "Category",
	};
};

export default useAdjustmentCategoriesColumn;
